import { I18N } from "oc-I18N";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";

export function ZaunCircleMenuItemFlipAnschlag() {
  const door = APP.arrangement.selectedObjects[0];
  const isMultiSelection = APP.arrangement.selectedObjects.length > 1;
  const currentSide = door?.anschlagAuswahlwert?.Key == "Anschlag_links" ? "left" : "right";

  if (isMultiSelection || door?.isDoppeltor || door?.isSchiebetor || !door?.isTor) return null;

  function handleFlip() {
    if (currentSide === "left") {
      const right = APP.richMetadata.findAuswahlwert("Anschlag_rechts");
      door.anschlagAuswahlwert = right;
    } else {
      const left = APP.richMetadata.findAuswahlwert("Anschlag_links");
      door.anschlagAuswahlwert = left;
    }

    APP.dirty();
    APP.logUserAction({ action: "flipAnschlag" });
  }

  return (
    <ZaunCircleMenuItem dataButtonKey={I18N("aria::Anschlag tauschen")} onClick={handleFlip}>
      {I18N("Drückerseite wechseln")}
    </ZaunCircleMenuItem>
  );
}
